var render = function render(){
  var _vm$cardData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "background rounded-xl"
    }
  }, [_c('v-card-text', [_c('table', [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-right py-1 pr-3"
  }, [_vm._v("Név")]), _c('td', {
    staticClass: "text--text font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.deviceData.name) + " ")])]), _c('tr', [_c('th', {
    staticClass: "text-right py-1 pr-3"
  }, [_vm._v("Szériaszám")]), _c('td', {
    staticClass: "text--text font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.deviceData.serialNumber) + " ")])]), _c('tr', [_c('th', {
    staticClass: "text-right py-1 pr-3"
  }, [_vm._v("Kapcsolat")]), _c('td', {
    staticClass: "text--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.deviceData.ip) + ":" + _vm._s(_vm.deviceData.port))])]), _c('tr', [_c('th', {
    staticClass: "text-right py-1 pr-3"
  }, [_vm._v("Belső óra")]), _c('td', {
    staticClass: "text--text font-weight-bold d-flex align-center"
  }, [_vm._v(" " + _vm._s(_vm._f("moment")(_vm.deviceData.time, 'lll')) + ":" + _vm._s(_vm._f("moment")(_vm.deviceData.time, 'ss')) + " "), _c('v-btn', {
    staticClass: "ml-auto rounded-xl",
    attrs: {
      "color": "primary",
      "text": "",
      "fab": "",
      "small": "",
      "title": "Kontroller idő szinkronizálása"
    },
    on: {
      "click": _vm.syncTime
    }
  }, [_c('v-icon', [_vm._v("mdi-sync")])], 1)], 1)]), _c('tr', [_c('th', {
    staticClass: "text-right py-1 pr-3"
  }, [_vm._v("HTTP API")]), _c('td', {
    staticClass: "text--text font-weight-bold"
  }, [_vm.deviceData.hasHttpApi ? _c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("mdi-check-bold")]) : _c('v-icon', {
    attrs: {
      "color": "error"
    }
  }, [_vm._v("mdi-close-thick")])], 1)])])]), _c('v-divider', {
    staticClass: "my-6"
  }), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-text-field', {
    attrs: {
      "label": "RFID alapú jogosultság ellenőrzés",
      "dense": "",
      "filled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.rfid,
      callback: function ($$v) {
        _vm.rfid = $$v;
      },
      expression: "rfid"
    }
  }), _c('v-btn', {
    staticClass: "ml-3 rounded-xl",
    attrs: {
      "color": "primary",
      "depressed": "",
      "fab": "",
      "small": ""
    },
    on: {
      "click": _vm.fetchCardInfo
    }
  }, [_c('v-icon', [_vm._v("mdi-magnify")])], 1)], 1), _vm.isCardDataFetched && !((_vm$cardData = _vm.cardData) !== null && _vm$cardData !== void 0 && _vm$cardData.cardNo) ? _c('div', [_c('v-alert', {
    staticClass: "my-3 rounded-xl",
    attrs: {
      "type": "error"
    }
  }, [_vm._v("Nincs találat a megadott RFID-vel ")])], 1) : _vm.isCardDataFetched ? _c('div', [_c('table', {
    staticClass: "my-6"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "py-1 pr-3 text-right"
  }, [_vm._v("Kártyaszám (DEC)")]), _c('td', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.cardData.cardNo))])]), _c('tr', [_c('td', {
    staticClass: "py-1 pr-3 text-right"
  }, [_vm._v("Érvényesség")]), _c('td', {
    staticClass: "font-weight-bold"
  }, [_vm.cardData.cardValid ? _c('v-chip', {
    attrs: {
      "color": _vm.cardData.cardValid ? 'success' : 'error',
      "small": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.cardData.cardValid ? 'Érvényes' : 'Nem érvényes'))]) : _vm._e()], 1)]), _c('tr', [_c('td', {
    staticClass: "py-1 pr-3 text-right"
  }, [_vm._v("Relé jogosultságok")]), _c('td', {
    staticClass: "font-weight-bold"
  }, _vm._l(_vm.cardData.doorRights, function (right, index) {
    return _c('v-chip', {
      key: `door-right-${index}`,
      staticClass: "mr-2",
      attrs: {
        "color": right ? 'success' : 'error',
        "small": "",
        "dark": ""
      }
    }, [_vm._v(" #" + _vm._s(index + 1) + ": " + _vm._s(right ? 'Jogosult' : 'Nem jogosult') + " ")]);
  }), 1)])])]), _vm._l(_vm.cardData.cardRightPlans, function (plan, index) {
    return _c('v-card', {
      key: `card-right-plan-${index}`,
      staticClass: "mt-3 rounded-xl",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', [_vm._v("Relé #" + _vm._s(index + 1) + " kártyajogok")]), _c('v-card-text', [_vm._l(plan, function (right) {
      return [right ? _c('v-card', {
        key: `card-right-plan-${index}-right-${right.index}`,
        staticClass: "mb-2 rounded-xl",
        attrs: {
          "flat": "",
          "color": "background"
        }
      }, [_c('v-card-title', [_vm._v(" Sablon #" + _vm._s(right.index) + " "), _c('v-chip', {
        staticClass: "ml-3",
        attrs: {
          "color": right.enabled ? 'success' : 'error',
          "small": "",
          "dark": ""
        }
      }, [_vm._v(" " + _vm._s(right.enabled ? 'Érvényes' : 'Nem érvényes') + " ")])], 1), _c('v-card-text', [_c('table', [_vm._l(right.segments, function (segment, jndex) {
        return _vm._l(segment, function (interval) {
          return _c('tr', {
            key: `card-right-plan-${index}-right-${right.index}-segment-${jndex}-interval-${segment.indexOf(interval)}`
          }, [interval && interval != null ? _c('div', [_c('td', {
            staticClass: "pr-3 text-right"
          }, [_vm._v(_vm._s(_vm.resolveDayName(jndex)))]), _c('td', [_vm._v(" " + _vm._s(_vm.formatTime(interval.begin)) + " - " + _vm._s(_vm.formatTime(interval.end)) + " ")])]) : _vm._e()]);
        });
      })], 2)])], 1) : _vm._e()];
    }), plan.every(function (e) {
      return !e;
    }) ? _c('div', [_vm._v("Nincs jogosultság erre a relére")]) : _vm._e()], 2)], 1);
  })], 2) : _vm._e(), _c('v-divider', {
    staticClass: "my-6"
  }), _c('v-row', [_vm._l(_vm.deviceData.weekPlans, function (weekplan, index) {
    return [weekplan.enabled ? _c('v-col', {
      key: `weekplan-${weekplan.index}`,
      staticClass: "my-3",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4",
        "xl": "2"
      }
    }, [_c('v-card', {
      staticClass: "rounded-xl",
      attrs: {
        "flat": "",
        "color": "backgound"
      }
    }, [_c('v-card-title', [_vm._v("Sablon #" + _vm._s(weekplan.index))]), _c('v-card-text', [index == 0 ? _c('div', [_vm._v("Alapértelmezett jogosultság: Mindig engedélyezve")]) : index == 1 ? _c('div', [_vm._v("Alapértelmezett jogosultság: Mindig tiltva")]) : _c('table', [_vm._l(weekplan.segments, function (segment, index) {
      return [segment[0] ? _c('tr', {
        key: `weekplan-${weekplan.index}-day-${weekplan.segments.indexOf(segment)}`
      }, [_c('td', {
        staticClass: "pr-3 text-right"
      }, [_vm._v(_vm._s(_vm.resolveDayName(index)))]), _c('td', {
        staticClass: "font-weight-bold"
      }, [_vm._v(" " + _vm._s(_vm.formatTime2(segment[0].begin)) + " - " + _vm._s(_vm.formatTime2(segment[0].end)) + " ")])]) : _vm._e()];
    })], 2)])], 1)], 1) : _vm._e()];
  })], 2)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }